import React from "react";
import { Form } from "../../../../primary";
import { FormActions } from "../../../../secondary";
import { ConfigForm } from "../../../../common/ConfigForm/ConfigForm";
import { BASIC_INFO_SECTIONS, BASIC_INFO_CUSTOM_VALIDATORS } from "../basicInfo.config";
import { BasicInfoStatusHeader } from "./BasicInfoStatusHeader";
import { CANCEL_BTN, SAVE_BTN } from "../../../../../constants";
import { PERMISSIONS } from "../../../../../constants/permissions";
import formStyle from "../../../../common/ConfigForm/ConfigForm.module.scss";
import styles from "../BasicInfo.module.scss";

export const BasicInfoEditMode = ({
  customerData,
  handleSubmit,
  doSubmit,
  register,
  errors,
  form,
  extra,
  hasPermission,
  submitErrors,
  onFieldChange,
  header,
  onToggleStatus,
  onSessionTimeoutChange,
  onSessionTimeoutTypeChange,
  previewImg,
  setPreviewImg,
  buttonState,
  setButtonState,
  onCancel,
  saveLoading,
}) => (
  <div className={formStyle.form_container}>
    <Form onSubmit={handleSubmit(doSubmit)} requiredPermission={PERMISSIONS.ADMIN_CUSTOMERS}>
      <BasicInfoStatusHeader
        editable
        customerData={customerData}
        header={header}
        errors={errors}
        register={register}
        onToggleStatus={onToggleStatus}
        onSessionTimeoutChange={onSessionTimeoutChange}
        onSessionTimeoutTypeChange={onSessionTimeoutTypeChange}
        previewImg={previewImg}
        setPreviewImg={setPreviewImg}
        buttonState={buttonState}
        setButtonState={setButtonState}
      />

      <div className={styles.columns}>
        <div className={styles.column}>
          <ConfigForm
            sections={BASIC_INFO_SECTIONS}
            column="left"
            extra={extra}
            hasPermission={hasPermission}
            form={form}
            errors={errors}
            submitErrors={submitErrors}
            onFieldChange={onFieldChange}
            register={register}
            customValidators={BASIC_INFO_CUSTOM_VALIDATORS}
          />
        </div>
        <div className={styles.column}>
          <ConfigForm
            sections={BASIC_INFO_SECTIONS}
            column="right"
            extra={extra}
            hasPermission={hasPermission}
            form={form}
            errors={errors}
            submitErrors={submitErrors}
            onFieldChange={onFieldChange}
            register={register}
            customValidators={BASIC_INFO_CUSTOM_VALIDATORS}
          />
        </div>
      </div>

      <FormActions
        primaryLabel={SAVE_BTN}
        primaryId="updateBtn"
        primaryType="submit"
        primaryLoading={saveLoading}
        secondaryLabel={CANCEL_BTN}
        secondaryId="cancelBtn"
        secondaryDisabled={saveLoading}
        onSecondaryClick={onCancel}
      />
    </Form>
  </div>
);
